import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { Filter, Main } from 'Containers/';
import { UnclosedDatesReportForm } from './components/UnclosedDatesReportForm';
import { UnclosedDatesReportFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { UNCLOSED_DATES_REPORT_FORM_NAME } from 'Common/FormEnum';
import {
  getUnclosedDatesReport,
  clearReport,
} from './state/uncloseddatesreport/actions';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { ReportGeneration } from 'Common/ObjectHelper';
import { createToast, toastType } from 'Common/ToastHelper';

class UnclosedDatesReportContainer extends Component {
  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: UNCLOSED_DATES_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;

    if (prevProps.report !== report && report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Unclosed Dates Report');
      }
      this.props.clearReport();
    }
  }

  handleSubmit = formValues => {
    this.props.getUnclosedDatesReport(formValues);
  };

  render() {
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Unclosed Dates Report'} />
        <Main {...this.getMainProps()}>
          <UnclosedDatesReportForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.FromDate]: defaultDateFormat(moment().subtract(1, 'day')),
              [Fields.ToDate]: defaultDateFormat(moment()),
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.UnclosedDatesReportState.unclosedDates.loading,
    report: state.UnclosedDatesReportState.unclosedDates.report,
  };
};

export const UnclosedDates = withRouter(
  connect(
    mapStateToProps,
    {
      getUnclosedDatesReport,
      clearReport,
    }
  )(UnclosedDatesReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/uncloseddates/UnclosedDates.js